export function getRouters (routers) {
  const menus = []
  for (const i in routers) {
    let routerRes = {}
    if (routers[i].children.length > 0 && routers[i].level<3) {
      routerRes = {
        path: routers[i].url,
        component: () => import('@/pages/' + routers[i].path),
        meta: {
          title: routers[i].title,
          icon: routers[i].icon
        },
        children: getRouters(routers[i].children)
      }
    }else{
      let role = [];
      if(routers[i].children.length>0){
        routers[i].children.forEach(item => {
          role.push({ id:item.url,title:item.title })
        });
      }
      routerRes = {
        path: routers[i].url,
        component: () => import('@/pages/' + routers[i].path),
        meta: {
          title: routers[i].title,
          icon: routers[i].icon,
          role:role
        }
      }
    }
    menus.push(routerRes)
  }
  return menus
}
//遍历第一个路由
export function currentRouting(routers){
  let firstRouter = routers[0].path;
  let value = '';
  if(routers[0].children && routers[0].children.length>0){
    value = '/'+currentRouting(routers[0].children);
  }
  firstRouter = firstRouter + value;
  return firstRouter;
}


// WEBPACK FOOTER //
// ./src/utile/RouterUtils.js